import { useTranslation } from 'react-i18next'
import { Activity, Component, SubmissionType } from '@cms-max/medicare-api-sdk'

import { MyDialog } from 'components/MyDialog'

import { ConfirmPasswordForm } from '../PasswordForm/ConfirmPasswordForm'
import { SecretQuestionModalForm } from './SecretQuestionModalForm'
import { useUpdateAccountHandler } from 'hooks/useUpdateAccountHandler'
import { useCallback, Dispatch } from 'react'
import { EditSecretQuestionFormData } from 'models/forms/SecretQuestionForm'
import { updateUser } from 'redux/reducers/users'
import { useModalCloseEvent } from 'components/MyDialog/useModalCloseEvent'

export type SecretQuestionModalProps = {
  onClose: () => void
}

const transformFormDataToRequestData = (formData: EditSecretQuestionFormData) => ({
  challengeQuestionAndAnswers: [
    {
      question: formData.question,
      answer: formData.answer
    }
  ]
})

const handleSuccessfulUpdate = (dispatch: Dispatch<any>, formData: EditSecretQuestionFormData) => {
  dispatch(updateUser({
    challenges: [{ question: formData.question }]
  }))
}

export const SecretQuestionModal = ({ onClose }: SecretQuestionModalProps) => {
  const { t } = useTranslation('editSecretQuestion')

  const trackSLSActivity = useCallback((respStatus: string) => {
    window.globalHeaderEvents?.handleEvent({
      core: {
        activity: Activity.DownstreamServiceResponse,
        component: Component.AccountSettings,
        property: 'MAX',
        elementId: 'accountsettings_secret_response',
        additionalData: {
          result: respStatus
        },
        submissionType: SubmissionType.Update
      }
    })
  }, [])

  const { handleSubmit, loading, serverErrors, password, user, setPassword } = useUpdateAccountHandler<EditSecretQuestionFormData>(
    { onClose, trackSLSActivity, transformFormDataToRequestData, handleSuccessfulUpdate }
  )
  const existingValues = { question: user?.challenges?.[0]?.question }

  const handleClose = useModalCloseEvent('accountSettings', 'accountsettings_secretclose_click', onClose)

  return (
    <MyDialog
      heading={t('heading')}
      containerId="medicare-my-acct-secret-question-settings"
      closeButtonAriaLabel={t('Close')}
      onClose={handleClose}
    >
      <>
        {!password
          ? (
          <>
            <p>{t('verifyText')}</p>
            <ConfirmPasswordForm onSubmit={setPassword} onClose={handleClose} />
          </>
            )
          : (
          <SecretQuestionModalForm
            existingValues={existingValues}
            loading={loading}
            onClose={handleClose}
            onSubmit={handleSubmit}
            serverErrors={serverErrors}
          />
            )}
      </>
    </MyDialog>
  )
}
